export const ListQueryKey = 'menus';
export const DetailQueryKey = 'menu';

export const Urls = {
  selectUrl: '/privileges/menu/list',
  updateUrl: '/privileges/menu/update',
  deleteUrl: '/privileges/menu/delete',
  createUrl: '/privileges/menu/create',
  detailUrl: '/privileges/menu/detail',
};
